<template>
  <form class="mt-2" id="form-modal">
    <!-- description input -->
    <div class="alert alert-danger alert-dismissible" v-if="empty">
      <a href="#" class="close" data-dismiss="alert" @click="quit">×</a>
      Fill All Fields
    </div>
    <div class="form-group">
      <label class="label-form">Current Password</label>
      <p class="alert alert-danger alert-dismissible" v-if="old_pass">
        <a href="#" class="close" data-dismiss="alert" @click="quit">×</a>
        You have entered wrong password.
      </p>
     <div>
        <input v-bind:type="[showPassword ? 'text' : 'password']" class="form-control password" name="current_password" v-model="current_password"
         placeholder="Enter Old Password" type="text" id="current_password" required />
     </div>
      <p v-if="current_password.length >= 1 && current_password.length < 8">
        <span class="text-danger">Password must be atleast 8 characters</span>
      </p>
    </div>
    <div class="form-group">
      <label class="label-form">Password</label>
      <input v-bind:type="[showPassword ? 'text' : 'password']" class="form-control password" name="password" v-model="password" 
              placeholder="Enter New Password" type="text" id="current_password" required />
      <p v-if="password.length >= 1 && password.length < 8">
        <span class="text-danger">Password must be atleast 8 characters</span>
      </p>
    </div>
    <!-- confirm password-->
    <div class="form-group">
      <label class="label-form">Confirm Password</label>
      <input v-bind:type="[showPassword ? 'text' : 'password']" class="form-control password" name="confirm_password" v-model="confirm_password" 
        placeholder="Confirm New Password" type="text" id="confirm_password" required />
      <p v-if="confirm_password.length >= 1 && confirm_password.length < 8">
        <span class="text-danger">Password must be identical</span>
      </p>
      <p class="alert alert-danger alert-dismissible" v-if="confirm_pass">
        <a href="#" class="close" data-dismiss="alert" @click="quit">×</a>
        The password confirmation does not match.
      </p>
    </div>
     <!-- Show Password -->
     <div class="control">
       <input type="checkbox" @click="showPassword = !showPassword"> Show Password
     </div>
    <!-- buttons -->
    <div class="form-footer text-right">
      <button type="button" class="btn btn-secondary btn-sm" data-dismiss="modal" @click="clear">
        Close
      </button>
      <button type="button" class="btn btn-primary btn-sm ml-1" @click="save">
        Save
      </button>
    </div>
  </form>
</template>

<script>
  import axios from 'axios';
  export default {

    props: [
      'action',

    ],
    data: function () {
      return {
        showPassword: false,
        current_password: '',
        password: '',
        confirm_password: '',
        old_pass: false,
        confirm_pass: false,
        empty: false
      };
    },
    created: function () {
      this.old_pass = false;
      this.confirm_pass = false;
      this.current_password = '';
      this.password = '';
      this.confirm_password = '';
    },
    methods: {
      save() {
        const permission = {
          headers: {
            'X-Permission': 'admin_users_resetpassword'
          }
        };
        var user_id = localStorage.getItem('admin_id');
        let current_password = this.current_password;
        let password = this.password;
        let confirm_password = this.confirm_password;

        if (this.validatePassword(password)) {
          if (password == confirm_password) {

            axios.post('/admin/users/reset-user-password', { oldPassword: current_password, newPassword: password, id: user_id },permission)
              .then((response) => {
                if (response.data.flag) {
                  this.old_pass = true;
                } else {
                  this.$toast.success(response.data.message);
                  window.$('#modal').modal('hide');
                  this.clear();
                }
              })
              .catch((error) => {
                let response = error.response;
                this.$toast.error(response.data.message);
              });
          } else {
            this.confirm_pass = true;
          }
        } else {
          this.$toast.error('The password must be atleast 8 characters');
        }

      },
      validatePassword(p) {
        if (p.length < 8) {
          return false;
        }
        return true;
      },

      clear() {
        this.old_pass = false;
        this.confirm_pass = false;
        this.current_password = '';
        this.password = '';
        this.confirm_password = '';
      },
      quit() {
        this.old_pass = false;
        this.confirm_pass = false;
        this.empty = false;
      }
    },
};
</script>